import React from "react";
import Skeleton from "@mui/material/Skeleton";
import Box from "@mui/material/Box";

const HotelListLoader: React.FC<{ count?: number }> = ({ count = 5 }) => {
  return (
    <>
      {Array.from({ length: count }).map((_, i) => (
        <Box
          key={i}
          className="mb-4 p-3 border rounded"
          sx={{ backgroundColor: "#fff" }}
        >
          <Box display="flex" gap={2}>
            {/* Hotel Image */}
            <Skeleton variant="rectangular" width={150} height={100} />

            {/* Hotel Info */}
            <Box flex={1}>
              <Skeleton variant="text" width="60%" height={24} />
              <Skeleton variant="text" width="40%" height={20} />
              <Skeleton variant="text" width="80%" height={20} />
              <Skeleton variant="text" width="30%" height={20} />
            </Box>

            {/* Price Info */}
            <Box display="flex" flexDirection="column" justifyContent="center" alignItems="flex-end">
              <Skeleton variant="text" width={80} height={20} />
              <Skeleton variant="text" width={100} height={30} />
            </Box>
          </Box>
        </Box>
      ))}
    </>
  );
};

export default HotelListLoader;
